import {
  BarChart3Icon,
  BookOpenIcon,
  FileTextIcon,
  LayoutDashboardIcon,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function ProductHeader() {
  return (
    <header className="bg-slate-800 text-white py-3 px-6">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-3">
  {/* Magnifying glass SVG logo */}
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="18" cy="18" r="12" stroke="#3B82F6" strokeWidth="4" fill="white" />
    <rect x="28" y="28" width="8" height="4" rx="2" transform="rotate(45 28 28)" fill="#3B82F6" />
  </svg>
  <h1 className="text-xl font-bold">SpyGlass</h1>
</div>
        </div>

        <nav className="hidden md:flex items-center gap-8">
          <Link
            to="/dashboard"
            className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors"
          >
            <LayoutDashboardIcon size={18} />
            <span>Dashboard</span>
          </Link>
          <Link
            to="/projects"
            className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors"
          >
            <BarChart3Icon size={18} />
            <span>Projects</span>
          </Link>
          <Link
            to="/ingredients"
            className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors"
          >
            <BookOpenIcon size={18} />
            <span>Ingredient Library</span>
          </Link>
          <Link
            to="/reports"
            className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors"
          >
            <FileTextIcon size={18} />
            <span>Reports</span>
          </Link>
        </nav>
      </div>
    </header>
  );
}
